export default __webpack_public_path__ + "static/hospitality-customer-feedback-shop-pressnxpress-718c83c81ebc6c350ee4127db676eb52.jpg";